import ChevronRight from '@ixigo/icons/ChevronRight';
import ButtonBase from '@ixigo/iui/ButtonBase';
import { InlineAlert } from '@ixigo/iui/InlineAlert';
import Typography from '@ixigo/iui/Typography';
import type { BookingSuccessResponse } from '@/api';
import { useNavigate } from '@/lib/navigation';

interface RescheduleRefundAlertProps {
	rescheduleRefundDetail: BookingSuccessResponse['data']['rescheduleRefundDetail'];
	parentBookingId?: string;
	className?: string;
}

export function RescheduleRefundAlert({
	rescheduleRefundDetail,
	parentBookingId,
	className = '',
}: RescheduleRefundAlertProps) {
	const navigate = useNavigate();

	if (!rescheduleRefundDetail || !parentBookingId) return null;

	const navigateToParent = () => {
		navigate({
			to: '/trips/$bookingId',
			params: { bookingId: parentBookingId },
			search: { confirmation: false },
			viewTransition: {
				types: ['slide-left'],
			},
		});
	};

	return (
		<ButtonBase
			onClick={navigateToParent}
			disableRipple
			className="w-full text-left"
		>
			<InlineAlert
				title={
					<Typography
						variant="body-sm"
						className="text-warning-moderate"
						// biome-ignore lint/security/noDangerouslySetInnerHtml: <static data just to show refund msg>
						dangerouslySetInnerHTML={{
							__html: rescheduleRefundDetail.text,
						}}
					/>
				}
				description={
					<Typography variant="body-xs" className="text-secondary">
						{rescheduleRefundDetail.subText}
					</Typography>
				}
				severity="warning"
				variant="moderate"
				closeBtnContent={<ChevronRight className="size-20 text-warning" />}
				onClose={navigateToParent}
				className={className}
			/>
		</ButtonBase>
	);
}
